import { useEffect, useState } from "react";
import { Table } from "antd";
import "./TriggerFlowPanels.css";
import { TableProps } from "antd/lib/table/Table";
import { TableProps as RcTableProps } from "rc-table/lib/Table";

const TriggerFlowPanels = ({
  inboxSource = [],
  inboxColumns,
  tableOptions,
  tableView,
  questionColumns,
  questionResponses,
  onRowClick,
  rowKey,
}: {
  tableView?: boolean;
  tableOptions?: TableProps<any>;
  inboxSource?: RcTableProps<object>["data"];
  inboxColumns?: any[];
  questionColumns: any[]; //ColumnsType<object>;
  questionResponses?: any[];
  onRowClick?: Function;
  rowKey: string;
}) => {
  const [selectedRow, setSelectedRow] = useState<any>(undefined);
  const [emptyMessage, setEmptyMessage] = useState<any>("");

  async function defineSelectedRow(row: any) {
    setSelectedRow(row);
    if (onRowClick) {
      await onRowClick(row);
    }
  }

  useEffect(() => {
    setEmptyMessage("");
    if (questionResponses && !questionResponses.length) {
      setEmptyMessage("There is no data");
    }
  }, [questionResponses]);

  useEffect(() => {
    setSelectedRow(undefined);
  }, [tableView]);

  useEffect(() => {
    //Maybe we need to create a prop to indicate what row should be active.
    if (!selectedRow && inboxSource[0]) {
      defineSelectedRow(inboxSource[0]);
    }
  }, [inboxSource]);
  return (
    <>
      {tableView ? (
        <div className="all-trigger-questions-container">
          {questionResponses &&
            questionResponses.length > 0 &&
            questionColumns && (
              <Table
                dataSource={questionResponses.sort(
                  (questionA: any, questionB: any) => {
                    return (
                      new Date(questionB.executionDate).getTime() -
                      new Date(questionA.executionDate).getTime()
                    );
                  }
                )}
                columns={questionColumns}
                rowKey={rowKey || "id"}
                scroll={{ x: questionColumns.length * 200 }}
                {...tableOptions}
              />
            )}
        </div>
      ) : (
        <div className="question-container">
          <div className="question-container-item trigger-information ">
            <Table
              dataSource={inboxSource}
              columns={inboxColumns}
              rowKey={rowKey || "id"}
              rowClassName={(record) => {
                return `row-item ${
                  record &&
                  selectedRow &&
                  record[rowKey] === selectedRow[rowKey]
                    ? "active-table-row"
                    : ""
                }`;
              }}
              onRow={(record) => {
                return {
                  onClick: () => {
                    defineSelectedRow(record);
                  },
                };
              }}
              {...tableOptions}
            />
          </div>
          <div className="question-container-item trigger-answers ant-card">
            {selectedRow && (
              <div className="date-title">
                <span className="bold">
                  {selectedRow?.orderDate.split(" ")[0] +
                    " " +
                    selectedRow?.orderDate.split(" ")[1]}
                </span>{" "}
                {selectedRow?.orderDate.split(" ")[2] +
                  " " +
                  selectedRow?.orderDate.split(" ")[3]}
              </div>
            )}

            {(questionResponses &&
              questionResponses.length &&
              questionColumns &&
              selectedRow &&
              questionColumns
                .filter(
                  ({ key }) => !["username", "executionDate"].includes(key)
                )
                .map((question, index) => {
                  return (
                    <div className="trigger-answers-container" key={index}>
                      <div className="trigger-answers-item trigger-answers-item-question ">
                        {question.title}
                      </div>
                      <div className="trigger-answers-item trigger-answers-item-answer">
                        {
                          questionResponses?.find((userResponses) => {
                            return (
                              userResponses.rootExecutionId ===
                              selectedRow.rootExecutionId
                            );
                          })[question.key]
                        }
                      </div>
                    </div>
                  );
                })) ||
              emptyMessage}
          </div>
        </div>
      )}
    </>
  );
};

export default TriggerFlowPanels;
